// extracted by mini-css-extract-plugin
export default {"symbolLogo":"SymbolLogo_symbolLogo__p844T","symbolLogoTextFallback":"SymbolLogo_symbolLogoTextFallback__eKJto"};